module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h6', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Комментарии к заказу")]), _vm._v(" "), (_vm.order.canOrderViewComments) ? [(_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем комментари..."
    }
  }) : _c('div', {
    staticClass: "chat-box"
  }, [(_vm.comments && _vm.comments.length > 0) ? _c('ul', {
    staticClass: "chat-list"
  }, [_vm._l((_vm.comments), function(comment, index) {
    return [(comment.user.id === _vm.user.id) ? _c('li', {
      staticClass: "chat-item odd"
    }, [_c('div', {
      staticClass: "chat-content"
    }, [(_vm.firstCommentUser(comment.user, index)) ? [_c('h5', [_vm._v("Вы")]), _vm._v(" "), _c('div', {
      staticClass: "small chat-diff-for-hummans"
    }, [_vm._v(_vm._s(comment.diffForHumans) + " - " + _vm._s(comment.date))])] : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "box bg-light-inverse"
    }, [_vm._v(_vm._s(comment.text))])], 2), _vm._v(" "), _c('div', {
      staticClass: "chat-time"
    }, [_vm._v(_vm._s(comment.time))])]) : _c('li', {
      staticClass: "chat-item",
      class: {
        'chat-new': !comment.isViewed
      }
    }, [_c('div', {
      staticClass: "chat-img"
    }, [_c('img', {
      attrs: {
        "src": _vm.getAvatarPath(comment.user.avatar),
        "alt": "user"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "chat-content"
    }, [_c('h5', [_vm._v(_vm._s(comment.user.fullname))]), _vm._v(" "), _c('div', {
      staticClass: "small chat-diff-for-hummans"
    }, [_vm._v(_vm._s(comment.diffForHumans) + " - " + _vm._s(comment.date) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "box bg-light-info"
    }, [_vm._v(_vm._s(comment.text))])]), _vm._v(" "), _c('div', {
      staticClass: "chat-time"
    }, [_vm._v(_vm._s(comment.time))])])]
  })], 2) : _c('div', {
    staticClass: "alert alert-warning mt-2"
  }, [_vm._v("\n                Пока никто не оставлял комментарии.\n            ")])])] : _c('div', {
    staticClass: "alert alert-warning mt-1"
  }, [_vm._v("\n            У вас недостаточно прав доступа для просмотра комментариев к этому заказу.\n        ")])], 2), _vm._v(" "), (_vm.order.canOrderAddComments) ? _c('div', {
    staticClass: "card-footer"
  }, [(_vm.sendLoading) ? _c('loading', {
    attrs: {
      "size": 2,
      "message": false
    }
  }) : _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.beforeSend($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group",
    class: {
      'has-danger': _vm.$v.commentText.$error
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.commentText),
      expression: "commentText",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Введите текст комментария",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.commentText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.commentText = $event.target.value.trim()
      }, function($event) {
        _vm.$v.commentText.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    class: {
      'disabled': _vm.$v.commentText.$invalid
    },
    attrs: {
      "disabled": _vm.$v.commentText.$invalid,
      "type": "submit"
    }
  }, [_vm._v("Опубликовать")])])]), _vm._v(" "), (_vm.$v.commentText.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Минимальна длинна комментария " + _vm._s(_vm.$v.commentText.$params.minLength.min) + " символа")]) : _vm._e()])], 1) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1b87075a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-1b87075a"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Comments.vue
// module id = 1004
// module chunks = 1